<template>
    <div class="page-container">
        <!-- Tab 切换栏 -->
        <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick" class="tabs-container">
            <el-tab-pane label="违规行为列表" name="list">
                <!-- 列表筛选栏 -->
                <el-form inline :model="searchForm" class="search-form">
                    <el-form-item label="开始时间">
                        <el-date-picker v-model="searchForm.startTime" type="datetime" placeholder="选择开始时间"
                            value-format="yyyy-MM-dd HH:mm" :disabled-date="disabledDate" />
                    </el-form-item>
                    <el-form-item label="-">
                        <el-date-picker v-model="searchForm.endTime" type="datetime" placeholder="选择结束时间"
                            value-format="yyyy-MM-dd HH:mm" :disabled-date="disabledDate" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                        <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
                <!-- 列表表格 直接绑定rawTableData，不再前端切片 -->
                <el-table :data="rawTableData" border style="width: 100%; margin-top: 20px;" height="62vh"
                    class="table-container" v-loading="tableLoading" element-loading-text="数据加载中...">
                    <!-- <el-table-column prop="index" label="序号" width="80" align="center" /> -->
                    <el-table-column prop="chid" label="通道编号" align="center" width="80" />
                    <el-table-column prop="ip" label="摄像头IP" align="center" min-width="120" />
                    <el-table-column prop="sn" label="设备序列号" align="center" min-width="180" />
                    <el-table-column prop="desc" label="违规项" align="center" min-width="150" />
                    <el-table-column prop="location" label="设备位置" align="center" min-width="120" />
                    <el-table-column prop="pic_data" label="违规图片" align="center" width="100" class-name="col-pic">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.pic_data" :src="scope.row.pic_data" fit="cover"
                                style="width: 80px; height: 60px; cursor: pointer;"
                                :preview-src-list="[scope.row.pic_data]" preview-teleport="body" />
                            <span v-else class="no-image">无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="违规时间" align="center" min-width="180">
                        <template slot-scope="scope">
                            {{ formatTimestamp(scope.row.timestamp) }}
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 列表分页组件 -->
                <div class="list-pagination-container">
                    <el-pagination @size-change="handleListSizeChange" @current-change="handleListCurrentChange"
                        :current-page="listCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="listPageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalTableCount" background>
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="健康证图片管理" name="healthCard">
                <!-- 健康证图片管理区域 -->
                <div class="health-card-container">
                    <!-- 头部：标题+说明+统计 -->
                    <div class="health-header">
                        <h3 class="header-title">健康证图片管理</h3>
                        <p class="header-desc">支持JPG/PNG格式图片上传，单张不超过200KB，最多可上传10张</p>
                        <div class="header-count">共 {{ healthCardImages.length }} 张图片</div>
                    </div>
                    <!-- 上传区域：独立一行，不参与分页 -->
                    <div class="upload-wrapper">
                        <el-upload class="health-upload" action="#" :http-request="handleHealthCardUpload"
                            list-type="picture-card" :on-preview="handlePicturePreview"
                            :on-remove="handleHealthCardRemove" :limit="maxUploadCount" :file-list="[]"
                            :auto-upload="true" :before-upload="beforeUpload" accept=".jpg,.png,.jpeg"
                            :disabled="healthCardImages.length >= maxUploadCount || isUploading"
                            v-loading="uploadLoading">
                            <i class="el-icon-plus" />
                            <div slot="tip" class="el-upload__tip" v-if="healthCardImages.length < maxUploadCount">
                                单张不超过200KB，最多上传10张
                            </div>
                            <div slot="tip" class="el-upload__tip upload-disabled" v-else>
                                已达到最大上传数量（10张）
                            </div>
                        </el-upload>
                    </div>
                    <!-- 图片列表：分页展示（一页6张） -->
                    <div class="health-list-container" v-if="healthCardImages.length > 0">
                        <div class="health-grid">
                            <div class="health-image-item" v-for="(img, index) in currentPageImages"
                                :key="img.id || img.uid" @click="handlePicturePreview(img)">
                                <el-image :src="img.picUrl || img.url" :alt="`健康证${index + 1}`" class="card-image"
                                    :preview-src-list="[img.picUrl || img.url]" preview-teleport="body" />
                                <div class="image-actions">
                                    <el-button icon="el-icon-delete" size="mini" type="text"
                                        @click.stop="handleHealthCardRemove(img)" class="delete-btn" />
                                </div>
                            </div>
                        </div>
                        <!-- 分页组件 -->
                        <div class="pagination-container">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="currentPage" :page-sizes="[6]" :page-size="pageSize"
                                layout="total, prev, pager, next, jumper" :total="healthCardImages.length" background />
                        </div>
                    </div>
                    <!-- 空状态提示（无图片时显示） -->
                    <div class="health-empty" v-if="healthCardImages.length === 0 && !uploadLoading">
                        <div class="empty-icon">
                            <i class="el-icon-picture-outline" />
                        </div>
                        <div class="empty-text">暂无健康证图片</div>
                        <div class="empty-desc">点击上传按钮添加健康证图片</div>
                    </div>
                </div>
                <!-- 预览弹窗 -->
                <el-dialog :visible.sync="dialogVisible" title="图片预览" width="90%" max-width="1200px" append-to-body
                    destroy-on-close class="preview-dialog">
                    <div class="preview-content">
                        <img :src="dialogImageUrl" alt="图片预览" class="preview-img" v-loading="previewLoading" />
                    </div>
                    <div slot="footer" class="preview-footer">
                        <el-button @click="dialogVisible = false">关闭</el-button>
                        <el-button type="primary" @click="downloadPreviewImg">下载图片</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { getBehaviorList, getTotal } from "@/api/xingwei";
import { addCarousel, getCarouselList, delCarousel } from "@/api/promotion";
// 获取今天凌晨 00:00 的格式化字符串 yyyy‑MM‑dd HH:mm
function getTodayMorningStr() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d} 00:00`;
}
// 获取当前时间 yyyy‑MM‑dd HH:mm
function getNowDateTimeStr() {
    const date = new Date();
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${mi}`;
}
export default {
    name: "ViolationAndHealthCard",
    data() {
        return {
            // 基础配置
            activeTab: 'list',
            maxUploadCount: 10,
            userId: localStorage.getItem('userId') || '',
            // 列表搜索条件
            searchForm: {
                startTime: '',
                endTime: ''
            },
            // 后端分页
            rawTableData: [],
            listCurrentPage: 0,
            listPageSize: 10,
            totalTableCount: 0,
            tableLoading: false,
            // 健康证图片相关
            healthCardImages: [],
            currentPage: 1,
            pageSize: 6,
            dialogVisible: false,
            dialogImageUrl: '',
            uploadLoading: false,
            previewLoading: false,
            isUploading: false
        }
    },
    computed: {
        currentPageImages() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.healthCardImages.slice(startIndex, endIndex);
        }
    },
    created() {
        if (!this.userId) {
            this.$message.warning("用户未登录，请重新登录后操作");
            return;
        }
        // 初始化默认时间：今日凌晨 ~ 当前时间
        this.searchForm.startTime = getTodayMorningStr();
        this.searchForm.endTime = getNowDateTimeStr();
        this.loadTableData();
        this.loadHealthCardImages();
    },
    methods: {
        // 拉取总条数
        async fetchTotalCount() {
            try {
                const params = {
                    userId: this.userId,
                    startTime: this.formatStrToTimestamp(this.searchForm.startTime),
                    endTime: this.formatStrToTimestamp(this.searchForm.endTime)
                }
                const res = await getTotal(params);
                // 根据后端返回格式适配，示例：res.data为总数字
                if (res?.data !== undefined) {
                    this.totalTableCount = Number(res.data) || 0;
                } else {
                    this.totalTableCount = Number(res) || 0;
                }
            } catch (err) {
                console.error("获取总条数失败", err);
                this.totalTableCount = 0;
            }
        },
        // 时间字符串转毫秒时间戳
        // 时间字符串(yyyy‑MM‑dd HH:mm)转毫秒时间戳：直接截断到分钟，丢弃秒
        // 时间字符串(yyyy‑MM‑dd HH:mm) → 秒级时间戳(去掉后3位毫秒)
        formatStrToTimestamp(timeStr) {
            if (!timeStr) return '';
            // 截取到分钟
            const trimMinuteStr = timeStr.slice(0, 16);
            const msTimestamp = new Date(trimMinuteStr).getTime();
            if (isNaN(msTimestamp)) return '';
            // 毫秒转秒，舍弃后3位
            return Math.floor(msTimestamp / 1000);
        }

        ,
        // 表格展示只到分钟 yyyy‑MM‑dd HH:mm
        formatTimestamp(timestamp) {
            if (!timestamp || isNaN(Number(timestamp))) {
                return '暂无时间';
            }
            let msTimestamp = Number(timestamp);
            if (msTimestamp.toString().length === 10) {
                msTimestamp *= 1000;
            }
            const date = new Date(msTimestamp);
            if (date.toString() === 'Invalid Date') {
                return '时间格式错误';
            }
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
        },
        disabledDate(date) {
            return date > new Date();
        },
        // 后端分页请求
        async loadTableData() {
            if (!this.userId) return;
            this.tableLoading = true;
            try {
                const params = {
                    userId: this.userId,
                    pageNum: this.listCurrentPage,
                    pageSize: this.listPageSize,
                    // 重点：转换为毫秒时间戳传给后端
                    startTime: this.formatStrToTimestamp(this.searchForm.startTime),
                    endTime: this.formatStrToTimestamp(this.searchForm.endTime)
                };
                // 并行请求：列表 + 总条数
                const [listResp] = await Promise.all([
                    getBehaviorList(params),
                    this.fetchTotalCount()
                ]);
                // 列表赋值
                if (listResp.data?.records) {
                    this.rawTableData = listResp.data.records;
                } else {
                    this.rawTableData = listResp.data || [];
                }
            } catch (error) {
                console.error('加载违规列表失败：', error);
                this.rawTableData = [];
                this.totalTableCount = 0;
                this.$message.error('数据加载失败');
            } finally {
                this.tableLoading = false;
            }
        },
        handleSearch() {
            // 移除时间为空的校验，初始化自带时间
            this.listCurrentPage = 0;
            this.loadTableData();
        },
        handleReset() {
            // 重置：恢复默认时间，不是清空
            this.searchForm.startTime = getTodayMorningStr();
            this.searchForm.endTime = getNowDateTimeStr();
            this.listCurrentPage = 0;
            this.loadTableData();
        },
        // 每页条数改变
        handleListSizeChange(val) {
            this.listPageSize = val;
            this.listCurrentPage = 1;
            this.loadTableData();
        },
        // 页码切换
        handleListCurrentChange(val) {
            this.listCurrentPage = val;
            this.loadTableData();
        },
        // ========== 健康证图片相关 ==========
        async loadHealthCardImages() {
            if (!this.userId) return;
            try {
                const res = await getCarouselList({
                    userId: this.userId,
                    picType: "健康证",
                });
                if (res.data && Array.isArray(res.data)) {
                    this.healthCardImages = res.data.filter(item => item.picUrl).map(item => ({
                        id: item.id,
                        uid: item.id || `health-${Date.now()}`,
                        picUrl: item.picUrl,
                        picName: item.picName || '健康证图片',
                        createTime: item.createTime || new Date().toLocaleString()
                    }));
                } else {
                    this.healthCardImages = [];
                }
            } catch (error) {
                console.error("加载健康证图片失败：", error);
                this.$message.error("加载健康证图片失败！");
                this.healthCardImages = [];
            }
        },
        async handleHealthCardUpload(options) {
            if (this.isUploading) {
                this.$message.warning("正在上传中，请稍候");
                options.onError(new Error("重复上传"));
                return;
            }
            const file = options.file;
            this.uploadLoading = true;
            this.isUploading = true;
            try {
                if (!this.userId) {
                    throw new Error("用户未登录");
                }
                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name || "健康证图片");
                formData.append("picType", "健康证");
                formData.append("sort", this.healthCardImages.length + 1);
                formData.append("userId", this.userId);
                const res = await addCarousel(formData);
                const newImage = {
                    id: res.data.id,
                    uid: res.data.id,
                    picUrl: res.data.picUrl,
                    picName: file.name,
                    createTime: new Date().toLocaleString()
                };
                this.healthCardImages.unshift(newImage);
                options.onSuccess(res.data);
                this.$message.success("健康证图片上传成功！");
                this.loadHealthCardImages()
                if (this.healthCardImages.length <= this.pageSize) {
                    this.currentPage = 1;
                }
            } catch (error) {
                console.error("健康证上传失败：", error);
                this.$message.error(`上传失败：${error.message || '网络错误'}`);
                options.onError(error);
            } finally {
                this.uploadLoading = false;
                this.isUploading = false;
            }
        },
        async handleHealthCardRemove(img) {
            try {
                if (!img || (!img.id && !img.uid)) {
                    this.$message.warning("无效的图片数据");
                    return;
                }
                await delCarousel({
                    id: img.id || img.uid,
                    userId: this.userId
                });
                this.healthCardImages = this.healthCardImages.filter(item =>
                    item.id !== img.id && item.uid !== img.uid
                );
                this.$message.success("图片已删除！");
                if (this.currentPageImages.length === 0 && this.currentPage > 1) {
                    this.currentPage--;
                }
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除图片失败：", error);
                    this.$message.error("删除失败！");
                }
            }
        },
        beforeUpload(file) {
            const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
            const isLt200K = file.size / 1024 < 200;
            if (!isImage) {
                this.$message.error('仅支持上传JPG/PNG格式图片');
                return false;
            }
            if (!isLt200K) {
                this.$message.error('图片大小不能超过200KB');
                return false;
            }
            return true;
        },
        handlePicturePreview(file) {
            this.previewLoading = true;
            this.dialogImageUrl = file.picUrl || file.url || file.response?.picUrl || file.objectURL;
            this.dialogVisible = true;
            setTimeout(() => {
                this.previewLoading = false;
            }, 500);
        },
        downloadPreviewImg() {
            if (!this.dialogImageUrl) {
                this.$message.warning("暂无可下载的图片");
                return;
            }
            try {
                const link = document.createElement('a');
                link.href = this.dialogImageUrl;
                link.download = `健康证_${new Date().getTime()}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success('图片下载中，请稍候');
            } catch (error) {
                console.error("下载图片失败：", error);
                this.$message.error("图片下载失败，请手动保存");
            }
        },
        handleTabClick(tab) {
            if (tab.name === 'healthCard') {
                this.loadHealthCardImages();
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        }
    },
    beforeDestroy() {
        this.dialogVisible = false;
        this.dialogImageUrl = '';
        this.isUploading = false;
        this.uploadLoading = false;
    }
}
</script>
<style lang="scss" scoped>
.page-container {
    .table-container {
        ::v-deep .col-pic .cell {
            white-space: normal !important;
            overflow: visible !important;
            text-overflow: clip !important;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}

.page-container {
    padding: 24px;
    background-color: #f9f9f9;
    min-height: 100vh;

    .tabs-container {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        overflow: hidden;

        ::v-deep .el-tabs__header {
            padding: 0 20px;
        }
    }

    .search-form {
        padding: 0 20px;
        margin-bottom: 20px;
        padding-top: 20px;

        ::v-deep .el-form-item {
            margin-bottom: 15px;
        }
    }

    .table-container {
        margin: 0 20px;

        ::v-deep .el-table__empty-text {
            color: #999;
            font-size: 14px;
        }

        .no-image {
            color: #999;
            font-size: 12px;
        }
    }

    .list-pagination-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
    }

    ::v-deep .el-table .el-image {
        transition: all 0.3s;

        &:hover {
            transform: scale(1.08);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
        }
    }

    .health-card-container {
        padding: 24px;
        background-color: #fff;
        border-radius: 8px;

        .health-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            flex-wrap: wrap;
            gap: 10px;

            .header-title {
                font-size: 16px;
                font-weight: 500;
                color: #333;
                margin: 0;
            }

            .header-desc {
                font-size: 12px;
                color: #999;
                margin: 0;
                flex: 1;
                min-width: 200px;
            }

            .header-count {
                font-size: 12px;
                color: #666;
                background-color: #f5f7fa;
                padding: 4px 12px;
                border-radius: 16px;
            }
        }

        .upload-wrapper {
            margin-bottom: 20px;

            ::v-deep .health-upload {
                .el-upload--picture-card {
                    width: 120px;
                    height: 120px;
                    border: 1px dashed #e5e6eb;
                    border-radius: 4px;
                    background-color: #fafafa;
                    transition: all 0.3s;

                    &:hover {
                        border-color: #409eff;
                        background-color: #f0f7ff;
                    }

                    .el-icon-plus {
                        font-size: 24px;
                        color: #409eff;
                    }
                }

                .upload-disabled {
                    color: #999;
                    background-color: #f5f5f5;
                    padding: 4px 0;
                }
            }
        }

        .health-list-container {
            .health-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                gap: 16px;
                margin-bottom: 24px;
            }

            .health-image-item {
                width: 100%;
                border-radius: 6px;
                overflow: hidden;
                background-color: #fff;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
                transition: all 0.3s;
                cursor: pointer;
                position: relative;

                &:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }

                ::v-deep .card-image {
                    width: 100% !important;
                    height: 160px !important;

                    .el-image__inner {
                        width: 100% !important;
                        height: 160px !important;
                    }
                }

                .image-actions {
                    display: flex;
                    justify-content: flex-end;
                    padding: 8px 10px;
                    background-color: #fafafa;
                    border-top: 1px solid #f0f0f0;

                    .delete-btn {
                        color: #f56c6c;
                        padding: 0;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &:hover {
                            background-color: rgba(245, 108, 108, 0.1);
                        }
                    }
                }
            }

            .pagination-container {
                display: flex;
                justify-content: center;
                margin-top: 20px;
                padding-top: 10px;
                border-top: 1px solid #f0f0f0;
            }
        }

        .health-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 60px 0;
            color: #999;

            .empty-icon {
                font-size: 48px;
                margin-bottom: 16px;
                color: #c0c4cc;
            }

            .empty-text {
                font-size: 16px;
                margin-bottom: 8px;
            }

            .empty-desc {
                font-size: 13px;
            }
        }

        .preview-dialog {
            ::v-deep .el-dialog__body {
                padding: 20px;
                max-height: 80vh;
                overflow: hidden;
            }

            .preview-content {
                text-align: center;
                padding: 10px 0;
            }

            .preview-img {
                max-width: 100%;
                max-height: 70vh;
                border-radius: 6px;
                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
            }

            .preview-footer {
                text-align: right;
            }
        }
    }
}
</style>
